import { apiClient } from './api'

export interface SetupProgress {
  org_id: number
  current_step: number
  steps_completed: number[]
  demo_data_loaded: boolean
  completed_at: string | null
  is_complete: boolean
}

export interface DashboardPreferences {
  user_id: number
  default_view: string
  notification_channels: Record<string, boolean>
  digest_frequency: string
  home_widgets: string[]
}

export const onboardingService = {
  getProgress: (orgId: number) =>
    apiClient.get<SetupProgress>(`/api/v1/onboarding/progress/${orgId}`).then(r => r.data),

  completeStep: (orgId: number, step: number) =>
    apiClient.post<SetupProgress>(`/api/v1/onboarding/progress/${orgId}/complete-step`, { step }).then(r => r.data),

  toggleDemo: (orgId: number) =>
    apiClient.post<SetupProgress>(`/api/v1/onboarding/progress/${orgId}/load-demo`).then(r => r.data),

  getMyPreferences: () =>
    apiClient.get<DashboardPreferences>('/api/v1/onboarding/preferences/me').then(r => r.data),

  updateMyPreferences: (prefs: Partial<DashboardPreferences>) =>
    apiClient.patch<DashboardPreferences>('/api/v1/onboarding/preferences/me', prefs).then(r => r.data),
}
